import React, { Component } from "react";
import { Card, Form, Button, Row, Col } from "react-bootstrap";
import axios from "axios";
import CommonToast from "../Toaster/CommonToast";
import CommonLoader from "../loaderComponent/CommonLoader";

export default class MeasurementBillAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      projects: [],
      workOrders: [],
      woItems: [],
      mbNumber: "",
      mbDate: "",
      customerId: "",
      projectId: "",
      workOrderId: "",
      status: "",
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: '',
      errors: {},
      isEdit: false,
      mbId: null,
    };
  }

  componentDidMount() {
    this.fetchCustomers();
    const mbId = this.props.match?.params?.id;
    if (mbId) {
      this.setState({ isEdit: true, mbId });
      this.fetchMeasurementBill(mbId);
    }
  }

  fetchCustomers = () => {
    axios
      .get("/customer")
      .then((res) => {
        this.setState({ customers: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchProjects = (customerId) => {
    axios
      .get(`/project/customer/${customerId}`)
      .then((res) => {
        this.setState({ projects: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchWorkOrders = (customerId, projectId) => {
    axios
      .get(`/workorders/${customerId}/${projectId}`)
      .then((res) => {
        this.setState({
          workOrders: res.data,
          loading: false
        });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchWoItems = (workOrderId) => {
    this.setState({ loading: true });
    axios
      .get(`/workorders/${workOrderId}`)
      .then((res) => {
        this.setState({
          woItems: res.data.items.map((item) => ({
            workOrderItemId: item.id,
            labourName: item.labour?.name || '',
            hsnCode: item.hsnCode,
            askedQuantity: item.quantity,
            serialNumber: item.serialNumber,
            pendingQuantity: item.pendingQuantity,
            uom: item.labour?.uomData?.name || '',
            rate: item.rate,
            quantity: 0,
            loading: false
          })),
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchMeasurementBill = (id) => {
    axios
      .get(`/measurementBill/${id}`)
      .then((res) => {
        const mb = res.data;
        this.setState({
          mbNumber: mb.mbNumber,
          mbDate: mb.mbDate,
          customerId: mb.customerId,
          projectId: mb.projectId,
          workOrderId: mb.workOrderId,
          status: mb.status,
          woItems: mb.items.map((item) => ({
            workOrderItemId: item.workOrderItemId,
            labourName: item.workOrderItem?.labour?.name,
            hsnCode: item.workOrderItem.hsnCode,
            askedQuantity: item.workOrderItem.quantity,
            pendingQuantity: item.workOrderItem.pendingQuantity,
            serialNumber: item.workOrderItem.serialNumber,
            uom: item.uom,
            quantity: item.quantity,
            rate: item.workOrderItem.rate,
          })),
        }, () => {
          this.fetchProjects(mb.customerId);
          this.fetchWorkOrders(mb.customerId, mb.projectId);
          setTimeout(() => {
            this.setState({ loading: false });
          }, 900);
        });
      })
      .catch((err) => {
        console.error("Error fetching measurement bill:", err);
        this.setState({
          showToast: true,
          toastMessage: "Failed to load measurement bill data",
          toastVariant: "danger",
          color: 'red'
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    this.setState(
      {
        customerId,
        projectId: "",
        workOrderId: "",
        projects: [],
        workOrders: [],
        woItems: [],
      },
      () => {
        if (customerId) {
          this.fetchProjects(customerId);
        }
      }
    );
  };

  handleProjectChange = (e) => {
    const projectId = e.target.value;
    this.setState(
      {
        projectId,
        workOrderId: "",
        workOrders: [],
        woItems: [],
      },
      () => {
        if (this.state.customerId && projectId) {
          this.fetchWorkOrders(this.state.customerId, projectId);
        }
      }
    );
  };

  handleWorkOrderChange = (e) => {
    const workOrderId = e.target.value;
    this.setState({ workOrderId, woItems: [] }, () => {
      if (workOrderId) {
        this.fetchWoItems(workOrderId);
      }
    });
  };

  handleWoItemQuantityChange = (index, value) => {
    const woItems = [...this.state.woItems];
    if (value === '') {
      woItems[index].quantity = '';
      this.setState({ woItems });
      return;
    }
    const quantity = parseFloat(value);
    if (isNaN(quantity)) return;
    if (quantity < 0) return;

    if (quantity > woItems[index].pendingQuantity) {
      this.setState({
        showToast: true,
        toastMessage: "Quantity cannot be more than pending quantity",
        toastVariant: "danger",
        color: 'red'
      });
      return;
    }

    woItems[index].quantity = quantity;
    this.setState({ woItems });
  };

  validateForm = () => {
    const errors = {};
    if (!this.state.customerId) errors.customerId = "Customer is required";
    if (!this.state.projectId) errors.projectId = "Project is required";
    if (!this.state.workOrderId) errors.workOrderId = "Work Order is required";

    const mbNumber = this.state.mbNumber.trim();
    const mbNumberRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~ ]{1,30}$/;

    if (!mbNumber) {
      errors.mbNumber = "MB Number is required";
    } else if (!mbNumberRegex.test(mbNumber)) {
      errors.mbNumber = "MB Number must be 1 to 30 characters and can include letters, numbers, and special characters";
    }
    if (!this.state.mbDate) errors.mbDate = "MB Date is required";

    this.state.woItems.forEach((item, index) => {
      if (item.quantity > item.pendingQuantity) errors[`quantity_${index}`] = "Quantity cannot exceed pending quantity";
      //if (item.quantity <= 0) errors[`quantity_${index}`] = "Quantity must be greater than 0";
    });

    return errors;
  };


  measurementBillList = () => {
    this.props.history.push('/measurement-bill')
  }

  handleSubmit = (status) => {
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({
        errors,
        showToast: true,
        toastMessage: "Please fix validation errors",
        toastVariant: "danger",
        color: 'red'
      });
      return;
    }

    this.setState({ loading: true });

    const {
      customerId,
      projectId,
      workOrderId,
      mbNumber,
      mbDate,
      woItems,
      isEdit,
      mbId,
    } = this.state;

    const payload = {
      customerId,
      projectId,
      workOrderId,
      mbNumber,
      mbDate,
      status,
      items: woItems.map(item => ({
        workOrderItemId: item.workOrderItemId,
        hsnCode: item.hsnCode,
        quantity: item.quantity,
        rate: item.rate,
        uom: item.uom,
      })),
    };

    const request = isEdit
      ? axios.put(`/measurementBill/${mbId}`, payload)
      : axios.post("/measurementBill", payload);

    request
      .then(() => {
        this.setState({
          showToast: true,
          toastMessage: `Measurement Bill ${isEdit ? "updated" : "created"} successfully!`,
          toastVariant: "success",
          color: 'green'
        });
        if (!isEdit) {
          this.setState({
            customerId: "",
            projectId: "",
            workOrderId: "",
            mbNumber: "",
            mbDate: "",
            woItems: [],
            errors: {},
          });
        }
        setTimeout(() => {
          this.measurementBillList();
          this.setState({
            loading: false
          })
        }, 600);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error saving Measurement Bill",
          toastVariant: "danger",
          color: 'red'
        });

      });
  };


  render() {
    const {
      customers,
      projects,
      workOrders,
      woItems,
      mbNumber,
      mbDate,
      customerId,
      projectId,
      workOrderId,
      status,
      errors,
      loading,
      isEdit,
    } = this.state;

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b>{isEdit ? "Update" : "Add"} Measurement Bill</b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.measurementBillList()}>
                    <i className="far fa-arrow-alt-circle-right"> Measurement Bill List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body style={{ marginBottom: '40px' }}>
                <Form onSubmit={this.onSubmit}>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={customerId}
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                          disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={projectId}
                          onChange={this.handleProjectChange}
                          isInvalid={!!errors?.projectId}
                          disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formWorkOrder">
                        <Form.Label className="required">Work Order</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={workOrderId}
                          onChange={this.handleWorkOrderChange}
                          isInvalid={!!errors?.workOrderId}
                          disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select WO NO.</option>
                          {workOrders.map((wo) => (
                            <option key={wo.id} value={wo.id}>
                              {wo.woNumber}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.workOrderId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formMbNumber">
                        <Form.Label className="required">MB Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="MB Number"
                          value={mbNumber}
                          onChange={(e) => this.setState({ mbNumber: e.target.value })}
                          isInvalid={!!errors?.mbNumber}
                          disabled={status === "Invoice" || status === "paid"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.mbNumber}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formMbDate">
                        <Form.Label className="required">MB Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={mbDate}
                          onChange={(e) => this.setState({ mbDate: e.target.value })}
                          isInvalid={!!errors?.mbDate}
                          disabled={status === "Invoice" || status === "paid"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.mbDate}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Items</h5>
                  {woItems.map((item, index) => (

                    <Card key={index} className="mb-3">
                      <Card.Body>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formSerialNumber${index}`}>
                              <Form.Label>S.No</Form.Label>
                              <Form.Control type="text" value={item.serialNumber} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formLabourName${index}`}>
                              <Form.Label>Labour</Form.Label>
                              <Form.Control type="text" value={item.labourName} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formHsnCode${index}`}>
                              <Form.Label>HSN Code</Form.Label>
                              <Form.Control type="text" value={item.hsnCode} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formAskedQuantity${index}`}>
                              <Form.Label>WO Qty</Form.Label>
                              <Form.Control type="number" value={item.askedQuantity} readOnly />
                            </Form.Group>
                          </Col>

                        </Row>
                        <Row>
                          <Col md={2}>
                            <Form.Group controlId={`formPendingQuantity${index}`}>
                              <Form.Label>Balance</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId={`formUom${index}`}>
                              <Form.Label>UOM</Form.Label>
                              <Form.Control type="text" value={item.uom} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formRate${index}`}>
                              <Form.Label>Rate</Form.Label>
                              <Form.Control type="number" value={item.rate} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formQuantity${index}`}>
                              <Form.Label>Measured Qty</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.quantity}
                                onChange={(e) => this.handleWoItemQuantityChange(index, e.target.value)}
                                isInvalid={!!errors?.[`quantity_${index}`]}
                                disabled={status === "invoiced" || status === "paid"}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`quantity_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formAmount${index}`}>
                              <Form.Label>Amount</Form.Label>
                              <Form.Control
                                type="number"
                                value={(item.quantity * item.rate).toFixed(2)}
                                readOnly
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
                  <div className="text-left mt-3">
                    <span className="status-btn">
                      <Button
                        variant='primary' className="px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary"
                        onClick={() => this.handleSubmit("Draft")}
                        disabled={status === "invoiced" || status === "paid"}
                      >
                        Save Draft
                      </Button>
                    </span>
                    <Button

                      variant="warning"
                      className="px-4 py-2 rounded-pill shadow-sm custom-add-button-generate btn btn-primary status-btn"
                      onClick={() => this.handleSubmit("Pending")}
                      disabled={status === "invoiced" || status === "paid"}
                    >
                      Generate MB
                    </Button>
                    <Button
                      variant='danger' className="px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel"
                      onClick={() => this.measurementBillList()}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader>
      </>
    );
  }
}